import { PencilIcon } from "@heroicons/react/outline";
import React, { useState } from "react";
import { Fragment } from "react";
import { useAsync } from "react-async";
import { Link, useHistory } from "react-router-dom";
import CascadingVariable from "../../../api/models/cascadingVariable";
import ProofingRule from "../../../api/models/proofingRule";
import { getCascadingVariables } from "../../../api/services/cascadingVariablesService";
import { getProofingRules } from "../../../api/services/proofingRulesService";
import DataTable from "../../../components/dataTable";
import Layout from "../../../components/layout";

const ViewProofing = () => {
  const [rules, setRules] = useState<ProofingRule[]>([]);
  const [variables, setVariables] = useState<CascadingVariable[]>([]);
  const history = useHistory();

  useAsync({
    promiseFn: getProofingRules,
    onResolve: (r) => {
      if (typeof r.data !== "undefined")
        setRules(r.data);
    },
  });

  useAsync({
    promiseFn: getCascadingVariables,
    onResolve: (r) => {
      if (typeof r.data !== "undefined")
        setVariables(r.data);
    }
  });

  const ruleColumns = React.useMemo(
    () => [
      {
        Header: 'Name',
        accessor: 'name',
      },
      {
        Header: 'Scope',
        accessor: (d: any) => d.scope.name,
      },
      {
        Header: 'Is Active',
        accessor: (d: any) => (d.isActive ? 'Yes' : 'No'),
      },
      {
        accessor: 'proofingRuleId',
        disableSortBy: true,
        Cell: (props: any) => {
          return (
            <div className='clearfix'>
              <span className='float-right'>
                <PencilIcon
                  className='w-5 h-5 cursor-pointer'
                  aria-hidden='true'
                />
              </span>
            </div>
          );
        },
        className: 'hidden sm:table-cell',
      },
    ],
    []
  );

  const varColumns = React.useMemo(
    () => [
      {
        Header: 'Name',
        accessor: 'variableName',
      },
      {
        Header: 'Default Value',
        accessor: 'defaultValue',
      },
      {
        Header: 'Is Active',
        accessor: (d: any) => (d.isActive ? 'Yes' : 'No'),
      },
      {
        accessor: 'cascadingVariableId',
        disableSortBy: true,
        Cell: (props: any) => {
          return (
            <div className='clearfix'>
              <span className='float-right'>
                <PencilIcon
                  className='w-5 h-5 cursor-pointer'
                  aria-hidden='true'
                />
              </span>
            </div>
          );
        },
        className: 'hidden sm:table-cell',
      },
    ],
    []
  );

  return (
    <Layout>
      <Fragment>

        <div className='flex justify-between mt-5'>
          <h2>Proofing Rules</h2>
          <Link className='btn' to='/admin/proofing/new'>
            Add Rule
          </Link>
        </div>

        <DataTable
          columns={ruleColumns}
          data={rules}
          showPagination={true}
          getRowProps={(row: any) => ({
            className: row.original.isMyMessage
              ? 'cursor-pointer hover:bg-purple-300 bg-purple-200'
              : 'cursor-pointer hover:bg-gray-100',
            onClick: () =>
              history.push(`/admin/proofing/${row.values.proofingRuleId}`),
          })}
        />

        <hr />

        <div className='flex justify-between mt-5'>
          <h2>Cascading Variables</h2>
          <Link className='btn' to='/admin/proofing/var/new'>
            Add Variable
          </Link>
        </div>

        <DataTable
          columns={varColumns}
          data={variables}
          showPagination={true}
          getRowProps={(row: any) => ({
            className: row.original.isMyMessage
              ? 'cursor-pointer hover:bg-purple-300 bg-purple-200'
              : 'cursor-pointer hover:bg-gray-100',
            onClick: () =>
              history.push(`/admin/proofing/var/${row.values.cascadingVariableId}`),
          })}
        />

      </Fragment>
    </Layout>
  )
}

export default ViewProofing;